import { render, staticRenderFns } from "./omt-icon.vue?vue&type=template&id=e5fea0d8&scoped=true&"
var script = {}
import style0 from "./omt-icon.vue?vue&type=style&index=0&id=e5fea0d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5fea0d8",
  null
  
)

export default component.exports